interface DetailTextSectionProps {
	title: string
	content?: string
	listItems?: string[]
	className?: string
}

export function DetailTextSection ({
	title,
	content,
	listItems,
	className = ''
}: DetailTextSectionProps) {
	return (
		<div className={`spaces-detail-text spaces:flex spaces:flex-col spaces:gap-8 ${className}`}>
			<h3 className='spaces:text-18/24 spaces:font-strong spaces:text-content-1'>{title}</h3>
			{content && (
				<p className='spaces:text-16/24 spaces:font-default spaces:text-content-2'>{content}</p>
			)}
			{listItems && listItems.length > 0 && (
				<ul className='spaces:list-disc spaces:pl-24 spaces:text-16/24 spaces:font-default spaces:text-content-2'>
					{listItems.map((item, i) => (
						<li key={i}>{item}</li>
					))}
				</ul>
			)}
		</div>
	)
}
